import imageUrl from "@/assets/images/resources/bg_img.png";
import imageUrlSm from "@/assets/images/resources/bg_img_sm.png";

export const becomeDealerDesktopButtonStyles = {
  display: { xs: "none", md: "block" },
  maxWidth: 294,
  textAlign: "center",
  mb: { md: 4 },
  py: { md: 1.75 },
};

export const becomeDealerMobileButtonStyles = {
  display: { xs: "block", md: "none" },
  width: "100%",
  maxWidth: 294,
  textAlign: "center",
  mx: "auto",
};

export const getBgImageStyles = (
  isSmallMobile: boolean,
  type: "primary" | "secondary"
) => ({
  position: "relative",
  boxSizing: "border-box",
  width: { xs: "100%", md: type === "primary" ? "90%" : "100%" },
  maxWidth: {
    xs: 380,
    md: type === "primary" ? 1390 : "100%",
  },
  mx: "auto",
  backgroundImage: { xs: `url(${imageUrlSm})`, md: `url(${imageUrl})` },
  backgroundSize: "cover",
  backgroundPosition: "center",
  px: { xs: isSmallMobile ? 2 : 3, md: 0 },
  pt: { xs: isSmallMobile ? 2 : 3, md: 0 },
});
